import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const formContainerStyle = css`
  border-top: solid 1px ${theme.colors.neutral20};
  position: relative;
  &:focus {
    outline: none;
  }
`;

export const formContainerNotEditStyle = css`
  padding-top: ${theme.spacing(1)};
`;

export const formContainerEditStyle = css`
  overflow: hidden;
`;

export const topRowContainerStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const topRowContainerEditStyle = css`
  padding: ${theme.spacing(2)};
`;

export const textAreaContainerStyle = css`
  flex: 1;
  margin: 0;
`;

export const textAreaContainerNotEditStyle = css`
  padding: ${theme.spacing(1, 2, 0, 2)};
`;

export const skeletonLoaderContainer = css`
  padding: ${theme.spacing(1)};
  & > div:first-child {
    max-width: 430px;
  }
`;

export const skeletonLoaderStyles = css`
  height: 16px;
  background: linear-gradient(90deg, #d9d9d9 0%, rgba(217, 217, 217, 0) 100%);
`;

export const actionButtonsContainerStyle = css`
  display: flex;
  margin-left: auto;
  justify-content: space-between;
`;

export const actionButtonsContainerNotEditStyle = css`
  padding-bottom: ${theme.spacing(1)};
`;

export const cancelButtonStyles = css`
  margin-right: ${theme.spacing(1)};
`;

export const sendBtnStyling = css`
  padding-top: ${theme.spacing(1)};
`;

export const sendBtnIconStyling = css`
  transform: rotate(45deg);
`;

export const bottomRowContainerStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const bottomRowContainerNotEditStyle = css`
  height: 40px;
  padding: ${theme.spacing(0, 2, 1, 1)};
`;

export const bottomRowContainerEditStyle = css`
  background: ${theme.colors.warning5};
  padding: ${theme.spacing(1)};
`;

export const invalidTextAreaStyle = css`
  outline: 1px solid ${theme.colors.critical50} !important;
  outline-offset: ${theme.spacing(1)};
`;

export const invalidMessageStyle = css`
  color: ${theme.colors.critical[50]};
  padding: ${theme.spacing(0, 0.5)};
`;

export const tagListStyle = css`
  border-top: 1px solid ${theme.colors.neutral20};
  margin-top: ${theme.spacing(1)};
  padding-top: ${theme.spacing(1)};
`;

export const messageTemplateStyle = css`
  margin-bottom: ${theme.spacing(2)};
  padding: 0;
  word-wrap: break-word;
  &:focus,
  &:focus-within {
    box-shadow: none;
  }
`;

export const componentTextStyle1 = css`
  padding: ${theme.spacing(0.25)};
`;

export const componentMessageTemplateEditorStyle2 = css`
  background-color: transparent;
`;

export const componentAutoGrowTextareaStyle3 = css`
  background-color: transparent;
`;

export const componentPStyle4 = css`
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const componentImageIconStyle7 = css`
  color: ${theme.colors.neutral70};

  button:disabled & {
    color: ${theme.font.colors.disabled};
  }
`;

export const componentTemplateIconStyle8 = css`
  color: ${theme.colors.neutral70};

  button:disabled & {
    color: ${theme.font.colors.disabled};
  }
`;

export const componentIconStyle9 = css`
  color: ${theme.colors.neutral70};

  button:disabled & {
    color: ${theme.font.colors.disabled};
  }
`;

export const emojiButtonStyles = css`
  height: 32px;
  width: 32px;
  padding: 4px;
`;
